<template>
  <el-dialog
    title="修改账户信息"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="editForm"
      label-width="100px"
    >
      <el-form-item label="公司名称" prop="companyName">
        <el-input
          v-model="form.companyName"
          placeholder="请输入公司名称"
          maxlength="50"
        ></el-input>
        <div v-if="companyNameError" class="error-tip">{{ companyNameError }}</div>
      </el-form-item>

      <el-form-item label="营业执照照片">
        <div v-if="licenseFileUrl">
          <a :href="licenseFileUrl" target="_blank" style="color: #409EFF;">{{ licenseFileName }}</a>
        </div>
        <div v-else>
          暂无营业执照照片
        </div>
        <div style="margin-top: 10px;">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept="image/*"
            name="fileVal"
          >
            <el-button size="small" type="primary">上传营业执照</el-button>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getCompanyInfo, updateCompany, createCompany } from '@/api/member'

export default {
  name: 'EditWccyrUser',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 公司名称验证规则
    const validateCompanyName = (rule, value, callback) => {
      if (!value) {
        this.companyNameError = '请输入公司名'
        callback(new Error('请输入公司名'))
      } else if (!/^[\(\)（）\u4e00-\u9fa5]{1,64}$/.test(value)) {
        this.companyNameError = '公司名格式不正确'
        callback(new Error('公司名格式不正确'))
      } else {
        this.companyNameError = ''
        callback()
      }
    }

    return {
      dialogVisible: this.visible,
      submitLoading: false,
      companyNameError: '',
      licenseFileUrl: '',
      licenseFileName: '',
      form: {
        companyName: '',
        licenseFileUrl: ''
      },
      rules: {
        companyName: [
          { required: true, validator: validateCompanyName, trigger: 'blur' }
        ]
      },
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        Authorization: 'Bearer ' + (localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.form.companyName = this.userData.company_name || ''
      this.licenseFileUrl = ''
      this.licenseFileName = ''
      this.form.licenseFileUrl = '' // 初始化表单中的licenseFileUrl
      
      if (this.userData.company_id && this.userData.company_id > 0) {
        try {
          const res = await getCompanyInfo({ id: this.userData.company_id })
          if (res.err_code === 0) {
            // 保存原始的营业执照URL
            this.userData.license_file_url = res.data.license_file_url || ''
            this.licenseFileUrl = res.data.license_file_url || ''
            this.form.licenseFileUrl = res.data.license_file_url || '' // 同步到表单数据
            if (this.licenseFileUrl) {
              this.licenseFileName = this.licenseFileUrl.substring(
                this.licenseFileUrl.lastIndexOf('/') + 1
              )
            }
          }
        } catch (error) {
          console.error('获取公司信息失败:', error)
        }
      }
    },

    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        this.form.licenseFileUrl = response.data
        this.licenseFileUrl = response.data
        this.licenseFileName = response.data.substring(
          response.data.lastIndexOf('/') + 1
        )
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 上传失败回调
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          // 先判断是否更改
          const isCompanyNameChanged = this.form.companyName !== this.userData.company_name
          // 修复license比较逻辑，应该与原始数据比较而不是当前显示的数据
          const isLicenseChanged = this.form.licenseFileUrl !== (this.userData.license_file_url || '')
          
          if (!isCompanyNameChanged && !isLicenseChanged) {
            this.$message.info('未做修改')
            this.handleClose()
            return
          }
          
          this.submitLoading = true
          try {
            let res
            const params = {}
            
            // 如果有公司ID，更新公司信息
            if (this.userData.company_id && this.userData.company_id > 0) {
              params.id = this.userData.company_id
              params.user_id = this.userData.id
              if (isCompanyNameChanged) {
                params.name = this.form.companyName
              }
              if (isLicenseChanged && this.form.licenseFileUrl) {
                params.license_file_url = this.form.licenseFileUrl
              }
              res = await updateCompany(params)
            } else {
              // 如果没有公司ID，创建公司
              params.user_id = this.userData.id
              params.name = this.form.companyName
              if (this.form.licenseFileUrl) {
                params.license_file_url = this.form.licenseFileUrl
              }
              res = await createCompany(params)
            }
            
            if (res.err_code === 0) {
              this.$message.success('保存成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.err_msg || '保存失败')
            }
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
</style>